import React from 'react';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';

const StartMenuModal = ({ id, title, onClose, data }) => {
  return (
    <Rnd
      default={{
        x: 280,
        y: -600,
        width: '50%',
        height: 'auto',
      }}
      minWidth={300}
      minHeight={200}
      dragHandleClassName="modal-drag-handle"
      className="absolute bg-white p-4 rounded-lg shadow-xl z-50 drop-all-shadow"
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center mb-4 modal-drag-handle cursor-move">
          <h2 className="text-lg">{title}</h2>
          <div className="flex space-x-2">
            <button className="w-3 h-3 bg-green-500 rounded-full cursor-pointer hover:bg-green-300 transition"></button>
            <button className="w-3 h-3 bg-yellow-500 rounded-full cursor-pointer hover:bg-yellow-300 transition"></button>
            <button
              className="w-3 h-3 bg-red-500 rounded-full cursor-pointer hover:bg-red-300 transition"
              onClick={() => onClose(id)}
            ></button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto">
          <div className="p-1 max-h-[400px]">
            {data}
          </div>
        </div>
      </div>
    </Rnd>
  );
};

StartMenuModal.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.node.isRequired,
};

export default StartMenuModal;
